import usePermission from "./usePermission";

function useClaimPermission(claims, checkIndividualOrGroupLevelWithoutleads) {
  return (
    claims.length === 0 || claims === null || usePermission(claims, null, "OR", checkIndividualOrGroupLevelWithoutleads)
  );
}

export default useClaimPermission;
